import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconClapboard: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="clapboard, movie, film"><path d="M20.25 3.75H3.75V20.25H20.25V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M4 8.75H20" stroke="currentColor" strokeWidth="1.5"/><path d="M8.25 8.75L10.25 3.75" stroke="currentColor" strokeWidth="1.5"/><path d="M13.75 8.75L15.75 3.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconClapboard;
